module.exports = __webpack_public_path__ + "img/plan-1-BG.dc012cc9.png";